/* eslint-disable no-useless-constructor */
import feathersClient, { BaseModel, makeServicePlugin } from "../../feathers-client";

class ERCOTRealTimePrices extends BaseModel {
  constructor(data, options) {
    super(data, options);
  }

  static modelName = "ERCOTRealTimePrices";
}

const servicePlugin = makeServicePlugin({
  Model: ERCOTRealTimePrices,
  service: feathersClient.service("data-services/ercot/real-time-locational-marginal-prices"),
  idField: "Bus Name",
  nameStyle: "path",
  getters: {},
});

export default servicePlugin;
